import { Component, Inject, OnDestroy, signal } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Subject, throwError } from "rxjs";
import { catchError, takeUntil } from "rxjs/operators";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { IonicModule } from "@ionic/angular";
import { NgStyle, AsyncPipe } from "@angular/common";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";
@Component({
    selector: "app-winmore-popup-endinbox",
    templateUrl: "./winmore-popup-endinbox.component.html",
    styleUrls: ["./winmore-popup-endinbox.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        NgStyle,
        AsyncPipe,
        SafeHtmlPipe,
    ],
})
export class WinMoreEndinboxComponent implements OnDestroy {
  inboxData$ = new BehaviorSubject<Data>({});
  alone$ = new BehaviorSubject<Data>({});
  together$ = new BehaviorSubject<Data>({});
  private ngUnsubscribe = new Subject<void>();
  winMoreData: Data;
  messageData: Data;
  currencySymbol: string;
  htmlContent: string;
  currencySymbolSignal = signal<string>("")
  htmlContentSignal = signal<string>("")
  contentTitleSignal = signal<string>("")

  contentTitle: string;
  constructor(
    private bottomSheet: MatBottomSheetRef<WinMoreEndinboxComponent>,
    public translate: TranslateService,
    private syndicateDataService: SyndicateDataService,
    private authService: AuthService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data
  ) {
    this.messageData = data;
    //  Currenty symbole based on user
    this.authService.userDetails$.subscribe(
      (user: Data) => {
        const preferredCurrency = user?.preferred_currency ? user?.preferred_currency : "GBP";
        this.authService.getCurrencyList$.subscribe((res: Data) => {
          const CurrencyDetails = res?.details?.find((x: Data) => x?.currency_code === preferredCurrency);
          this.currencySymbolSignal.set(CurrencyDetails?.currency_symbol ? CurrencyDetails?.currency_symbol : "£")
          this.currencySymbol = this.currencySymbolSignal()
          this.currencySymbol = CurrencyDetails?.currency_symbol ? CurrencyDetails?.currency_symbol : "£";
        });
      },
      (err) => {
        return err;
      }
    );
    // This method has been used to get the inbox message
    this.syndicateDataService
      .getWinMoreInboxEnd()
      .pipe(
        catchError((err) => {
          console.error(err); // Add error handling
          return throwError(err);
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((data: Data) => {
        if (!data || !data.content) {
          return;
        }
        try {
          this.inboxData$.next(data);
          const TEMPLATE_END_USER_WON = "wmp_end_user_won";
          const TEMPLATE_WE_WON = "wmp_end_we_won";
          // Condition for wmp_end_user_won
          const typeOfTemplate = this.messageData.template_data?.type;
          if (this.messageData.template_data?.amount_difference && typeOfTemplate === TEMPLATE_END_USER_WON) {
            const description = data?.content?.alone.description;
            if (typeof description === "string") {
              const arr = description.split("add"); // Splitting the string by "add"
              const content = arr.join(
                "add " + "<strong>" + this.currencySymbol + this.data?.template_data?.amount_difference + "</strong>"
              );
              this.contentTitleSignal.set(data?.content?.alone.title);
              this.contentTitle = this.contentTitleSignal()
              // this.contentTitle = data?.content?.alone.title;
              this.htmlContentSignal.set(content);
              this.htmlContent = this.htmlContentSignal()
              this.htmlContent = content;
            }
          }
          // Condition for wmp_end_we_won
          else if (typeOfTemplate === TEMPLATE_WE_WON) {
            this.contentTitle = data?.content?.together?.title;
            this.htmlContent = data?.content?.together.description;
          }
        } catch (error) {
          return error;
        }
      });
  }

  close() {
    this.bottomSheet.dismiss();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  // This method has been used to get the progress
  getProgressBar(isAlone: boolean) {
    const aloneCount = this.data.template_data.alone_won;
    const togetherCount = this.data.template_data.we_won;
    if (aloneCount && togetherCount) {
      const totalWinnings = togetherCount + aloneCount;
      const progress = Math.round(((isAlone ? aloneCount : togetherCount) / totalWinnings) * 100);
      return progress;
    } else {
      return 0;
    }
  }

  closeDialog() {
    this.bottomSheet.dismiss();
  }
}
